import type { Catalog } from './types.ts';
import enUS from './locales/en-US/messages.ts';

export const catalog: Catalog = {
  'en-US': enUS,
};
